import { useState } from "react";
import PropTypes from "prop-types";
import { createUseStyles } from "react-jss";
import Icon from "../../icon";
import inputPasswordReadOnlySkin from "../../../../skins/input-password-read-only.skin";

const useStyles = createUseStyles(inputPasswordReadOnlySkin);

const InputPasswordReadOnly = ({ value = "", className }) => {
  const [showPassword, setShowPassword] = useState(false);
  const classes = useStyles();

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className={className}>
      {showPassword ? value : "•".repeat(value.length)}
      {value && (
        <span className={classes.iconButton} onClick={togglePasswordVisibility}>
          {showPassword ? <Icon icon="eye-slash" /> : <Icon icon="eye" />}
        </span>
      )}
    </div>
  );
};

InputPasswordReadOnly.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
};

export default InputPasswordReadOnly;
